import { ReactNode, useState } from 'react';
import { Checkbox } from '@qlub-dev/qlub-kit';
import { Dialog, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import PhoneInputV2, { IPhoneInputV2Props } from '../../PhoneInputV2';
import { useTranslation } from '../../../hook/translations';

interface Props extends IPhoneInputV2Props {
    errorText?: string;
    acceptTermsAndCondition?: boolean;
    showTermsAndCondition?: boolean;
    termsAndConditionLabel?: ReactNode;
    termsAndConditionContent?: ReactNode;
    onChangeAcceptTermsAndCondition: (checked: boolean) => void;
}

const Phone = ({
    lang,
    defaultCountry,
    value,
    errorText,
    acceptTermsAndCondition,
    showTermsAndCondition,
    termsAndConditionLabel,
    termsAndConditionContent,
    onChange,
    onChangeAcceptTermsAndCondition,
    validation,
}: Props) => {
    const [showDialog, setShowDialog] = useState(false);
    const toggle = () => setShowDialog(!showDialog);
    const { t } = useTranslation('common');

    return (
        <div>
            <PhoneInputV2
                value={value}
                placeholder={t('Mobile number')}
                errorText={errorText}
                onChange={onChange}
                lang={lang}
                defaultCountry={defaultCountry}
                validation={validation}
                countrySearchLabel={t('Search for countries')}
                required
            />
            {showTermsAndCondition && (
                <Stack direction="row" alignItems="start">
                    <Checkbox
                        checked={!!acceptTermsAndCondition}
                        onClick={() => onChangeAcceptTermsAndCondition(!acceptTermsAndCondition)}
                        label=""
                    />
                    <Typography role="button" onClick={toggle}>
                        {termsAndConditionLabel}
                    </Typography>
                </Stack>
            )}

            <Dialog fullWidth open={showDialog} onClose={toggle}>
                <DialogTitle>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6"> {t('Terms and Conditions')}</Typography>
                        <IconButton edge="end" onClick={toggle}>
                            <CloseRounded />
                        </IconButton>
                    </Stack>
                </DialogTitle>
                {termsAndConditionContent}
            </Dialog>
        </div>
    );
};

export default Phone;
